/* unplugin-vue-components disabled */const { computed, ref } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-3f4b6428"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "center-panel-wrap" };
const _hoisted_2 = { class: "path-list-wrap" };
const _hoisted_3 = { class: "list-header-wrap" };
const _hoisted_4 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "自动取料", -1));
const _hoisted_5 = { class: "feed-bin-content" };
const _hoisted_6 = { class: "program-path-wrap" };
const ListItem_vue_1 = tslib_1.__importDefault(require("./ListItem.vue"));
const FeedBin_vue_1 = tslib_1.__importDefault(require("./FeedBin.vue"));
const model_1 = require("@/model");
const work_1 = require("@/store/modules/work");
const one_message_1 = require("@/utils/one_message");
const laborer_1 = require("@/store/modules/laborer");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PointListPanel',
    setup(__props, { expose: __expose }) {
        const curRobot = computed(() => { var _a; return (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.curProgram.robot; });
        const hasAutoAdd = computed(() => {
            var _a;
            if (!((_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.code.programs))
                return false;
            let program = curRobot.value.code.programs;
            let programsStr = JSON.stringify(program);
            return programsStr.indexOf('"type":"move_material"') > -1;
        });
        const feedBins = computed(() => {
            var _a;
            return (((_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.paths) || []).filter(path => path.type === 'route' && path.ioId) || [];
        });
        const feedBinListRef = ref();
        const cfgPaths = computed(() => {
            var _a;
            return (((_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.paths) || []).filter(path => (['route', 'point', 'joints', 'jointPoint'].includes(path.type)) && !path.ioId && path.isTeach) || [];
        });
        const workStore = (0, work_1.useWork)();
        const laborerStore = (0, laborer_1.useLaborer)();
        function delPoint(info) {
            try {
                info.points.splice(info.pointIndex, 1);
                laborerStore.selectPoint();
                (0, one_message_1.oneMessage)({ message: "删除成功", type: 'success' });
            }
            catch (e) {
                (0, one_message_1.oneMessage)({ message: "删除失败", type: 'error' });
            }
        }
        const pathGroup = computed(() => { var _a; return ((_a = curRobot.value) === null || _a === void 0 ? void 0 : _a.code.processGroups) || []; });
        function onAddFeedBinClick(evt) {
            evt.stopPropagation();
            let io = curRobot.value.code.addIO("#0", model_1.IO_TYPE.DI, undefined, undefined, undefined, undefined, 'feedBin');
            let feedBin = curRobot.value.addPath(`料仓`, [[0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0]], 'route', io.id, true, '$cang');
            io.remark = feedBin.name;
            if (feedBinListRef.value) {
                feedBinListRef.value.openCollapse();
            }
        }
        const feedBinsRefs = feedBins.value.map(() => ref(null));
        const pathGroupRefs = pathGroup.value.map(() => ref(null));
        const setFeedBinsRef = (key) => {
            return (el) => {
                feedBinsRefs[key] = el;
            };
        };
        const setPathGroupRefs = (key) => {
            return (el) => {
                pathGroupRefs[key] = el;
            };
        };
        const playSavePointAnimate = () => {
            let pathId = laborerStore.pointState.path.id;
            let pathRef = feedBinsRefs[pathId] || pathGroupRefs[pathId];
            if (pathRef) {
                pathRef.playSaveAnimate(laborerStore.pointState.pointIndex);
            }
        };
        function handleNextPoint() {
            if (laborerStore.pointState) {
                if (laborerStore.pointState.pointIndex + 1 < laborerStore.pointState.path.points.length) {
                    laborerStore.selectPoint(laborerStore.pointState.path, laborerStore.pointState.pointIndex + 1);
                }
                else {
                    let curPath = laborerStore.pointState.path;
                    const selectNextPoint = (paths) => {
                        let pathIndex = paths.findIndex(path => path.id === curPath.id);
                        if (pathIndex + 1 >= paths.length) {
                            pathIndex = -1;
                        }
                        laborerStore.selectPoint(paths[pathIndex + 1], 0);
                    };
                    if (curPath.type === "route" && !!curPath.ioId) {
                        selectNextPoint(feedBins.value);
                    }
                    else {
                        let paths = cfgPaths.value.filter(path => path.group === curPath.group);
                        if (paths[paths.length - 1].id !== curPath.id) {
                            selectNextPoint(paths);
                        }
                        else {
                            let groupIndex = pathGroup.value.indexOf(curPath.group);
                            groupIndex = groupIndex + 1 === pathGroup.value.length ? -1 : groupIndex;
                            paths = cfgPaths.value.filter(path => path.group === pathGroup.value[groupIndex + 1]);
                            laborerStore.selectPoint(paths[0], 0);
                        }
                    }
                }
            }
        }
        function handlePrePoint() {
            if (laborerStore.pointState) {
                if (laborerStore.pointState.pointIndex - 1 > -1) {
                    laborerStore.selectPoint(laborerStore.pointState.path, laborerStore.pointState.pointIndex - 1);
                }
                else {
                    let curPath = laborerStore.pointState.path;
                    const selectPrePoint = (paths) => {
                        let pathIndex = paths.findIndex(path => path.id === curPath.id);
                        if (pathIndex - 1 < 0) {
                            pathIndex = paths.length;
                        }
                        laborerStore.selectPoint(paths[pathIndex - 1], paths[pathIndex - 1].points.length - 1);
                    };
                    if (curPath.type === "route" && !!curPath.ioId) {
                        selectPrePoint(feedBins.value);
                    }
                    else {
                        let paths = cfgPaths.value.filter(path => path.group === curPath.group);
                        if (paths[0].id === curPath.id) {
                            let groupIndex = pathGroup.value.indexOf(curPath.group);
                            groupIndex = groupIndex == 0 ? pathGroup.value.length : groupIndex;
                            paths = cfgPaths.value.filter(path => path.group === pathGroup.value[groupIndex - 1]);
                            let targetPath = paths[paths.length - 1];
                            laborerStore.selectPoint(targetPath, targetPath.points.length - 1);
                        }
                        else {
                            selectPrePoint(paths);
                        }
                    }
                }
            }
        }
        __expose({
            handleNextPoint,
            handlePrePoint,
            hasAutoAdd,
            playSavePointAnimate
        });
        return (_ctx, _cache) => {
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    ((0, vue_2.unref)(hasAutoAdd))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ListItem_vue_1.default, {
                            key: 0,
                            ref_key: "feedBinListRef",
                            ref: feedBinListRef
                        }, {
                            header: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                    _hoisted_4,
                                    (0, vue_2.createVNode)(_component_el_button, {
                                        onClick: onAddFeedBinClick,
                                        icon: "Plus",
                                        size: "small"
                                    }, {
                                        default: (0, vue_2.withCtx)(() => [
                                            (0, vue_2.createTextVNode)("添加料仓")
                                        ]),
                                        _: 1
                                    })
                                ])
                            ]),
                            content: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(feedBins), (feedBin) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(FeedBin_vue_1.default, {
                                            key: `feedBin${feedBin.id}`,
                                            mode: "feedBin",
                                            "feed-bin": feedBin,
                                            ref_for: true,
                                            ref: setFeedBinsRef(feedBin.id)
                                        }, null, 8, ["feed-bin"]));
                                    }), 128))
                                ])
                            ]),
                            _: 1
                        }, 512))
                        : (0, vue_2.createCommentVNode)("", true),
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(pathGroup), (group, index) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ListItem_vue_1.default, {
                            key: `group${index}`
                        }, {
                            header: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(group.name), 1)
                            ]),
                            content: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(cfgPaths).filter(path => path.group === group.id), (path) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(FeedBin_vue_1.default, {
                                            key: `point${path.id}`,
                                            "feed-bin": path,
                                            mode: ['jointPoint', 'point'].includes(path.type) ? 'point' : 'path',
                                            ref_for: true,
                                            ref: setPathGroupRefs(path.id)
                                        }, null, 8, ["feed-bin", "mode"]));
                                    }), 128))
                                ])
                            ]),
                            _: 2
                        }, 1024));
                    }), 128))
                ])
            ]));
        };
    }
});
